// Unified Permissions System - Standardized snake_case format
export const Permissions = {
  // Navigation & Pages
  NAVIGATION_USERS: 'navigation.users', // NavigationPermissions.USERS
  NAVIGATION_MODELS: 'navigation.models', // NavigationPermissions.MODELS
  NAVIGATION_ROTA: 'navigation.rota', // NavigationPermissions.ROTA
  NAVIGATION_EXCHANGE_RATES: 'navigation.exchange_rates', // NavigationPermissions.EXCHANGE_RATES
  NAVIGATION_ROLES: 'navigation.roles', // NavigationPermissions.ROLES
  NAVIGATION_TICKETS: 'navigation.tickets', // NavigationPermissions.TICKETS
  NAVIGATION_WEEKEND_STAFFING: 'navigation.weekend_staffing', // NavigationPermissions.WEEKEND_STAFFING
  NAVIGATION_AUDIT_LOGS: 'navigation.audit_logs', // NavigationPermissions.AUDIT_LOGS
  NAVIGATION_PROMO_DISTRIBUTION: 'navigation.promo_distribution', // NavigationPermissions.PROMO_DISTRIBUTION
  NAVIGATION_DASHBOARD_SETTINGS: 'navigation.dashboard_settings', // NavigationPermissions.UPDATE_DASHBOARD_SETTINGS
  NAVIGATION_COSTS: 'navigation.costs', // NavigationPermissions.COSTS

  // Regular Shifts
  SHIFTS_VIEW: 'shifts.view', // ShiftPermissions.VIEW
  SHIFTS_VIEW_ALL: 'shifts.view_all',
  SHIFTS_CREATE: 'shifts.create', // ShiftPermissions.CREATE
  SHIFTS_EDIT: 'shifts.edit', // ShiftPermissions.EDIT
  SHIFTS_DELETE: 'shifts.delete', // ShiftPermissions.DELETE
  SHIFTS_COMPLETE: 'shifts.complete', // ShiftPermissions.COMPLETE
  SHIFTS_SPLIT: 'shifts.split', // ShiftPermissions.SPLIT
  SHIFTS_CLOCK_IN: 'shifts.clock_in', // ShiftPermissions.CLOCK_IN
  SHIFTS_VIEW_UNCLOCKED: 'shifts.view_unclocked', // ShiftPermissions.VIEW_UNCLOCKED
  SHIFTS_VERIFY: 'shifts.verify', // ShiftPermissions.VERIFY

  // Fixed Shifts
  FIXED_SHIFTS_VIEW: 'fixed_shifts.view', // FixedRotaShiftPermissions.VIEW
  FIXED_SHIFTS_CREATE: 'fixed_shifts.create', // FixedRotaShiftPermissions.CREATE
  FIXED_SHIFTS_EDIT: 'fixed_shifts.edit', // FixedRotaShiftPermissions.EDIT
  FIXED_SHIFTS_DELETE: 'fixed_shifts.delete', // FixedRotaShiftPermissions.DELETE
  FIXED_SHIFTS_CONVERT: 'fixed_shifts.convert', // FixedRotaShiftPermissions.CONVERT

  // Schedule Shifts
  SCHEDULE_VIEW: 'schedule.view', // SchedulePermissions.VIEW
  SCHEDULE_VIEW_ALL: 'schedule.view_all',
  SCHEDULE_CREATE: 'schedule.create', // SchedulePermissions.CREATE
  SCHEDULE_EDIT: 'schedule.edit', // SchedulePermissions.EDIT
  SCHEDULE_DELETE: 'schedule.delete', // SchedulePermissions.DELETE
  SCHEDULE_COMPLETE: 'schedule.complete', // SchedulePermissions.COMPLETE
  SCHEDULE_EDIT_RESET_TIMER: 'schedule.edit_reset_timer', // SchedulePermissions.EDIT_RESET_TIMER
  SCHEDULE_VIEW_UK: 'schedule.view_uk', // SchedulePermissions.VIEW_UK
  SCHEDULE_VIEW_FP: 'schedule.view_fp', // SchedulePermissions.VIEW_FP
  SCHEDULE_VIEW_FORMAT_LIST: 'schedule.view_format_list', // SchedulePermissions.VIEW_FORMAT_LIST

  SCHEDULE_FIXED_SHIFTS_VIEW: 'schedule_fixed_shifts.view',
  SCHEDULE_FIXED_SHIFTS_MANAGE: 'schedule_fixed_shifts.manage',

  // Spam Shifts
  SPAM_SHIFTS_VIEW: 'spam_shifts.view', // SpamShiftPermissions.VIEW
  SPAM_SHIFTS_VIEW_ALL: 'spam_shifts.view_all',
  SPAM_SHIFTS_MANAGE: 'spam_shifts.manage', // SpamShiftPermissions.MANAGE

  SPAM_FIXED_SHIFTS_MANAGE: 'spam_fixed_shifts.manage',

  // Supervisor Shifts
  SUPERVISOR_SHIFTS_VIEW: 'supervisor_shifts.view',
  SUPERVISOR_SHIFTS_MANAGE: 'supervisor_shifts.manage', // SupervisorShiftPermissions.MANAGE

  SUPERVISOR_FIXED_SHIFTS_MANAGE: 'supervisor_fixed_shifts.manage',

  // GG Swaps
  GG_SWAP_MANAGE: 'gg_swap.manage', // GGSwapPermissions.MANAGE

  // Fan Gain
  FAN_GAIN_MANAGE: 'fan_gain.manage', // FanGainPermissions.MANAGE

  // Users
  USERS_CREATE: 'users.create', // UserPermissions.CREATE
  USERS_EDIT: 'users.edit', // UserPermissions.EDIT
  USERS_DELETE: 'users.delete', // UserPermissions.DELETE
  USERS_EDIT_ANY: 'users.edit_any', // UserPermissions.EDIT_ANY
  USERS_VIEW_OTHERS: 'users.view_others', // UserPermissions.VIEW_OTHER_USERS
  USERS_VIEW_WARNINGS: 'users.view_warnings', // UserPermissions.VIEW_WARNINGS
  USERS_ADD_WARNING: 'users.add_warning', // UserPermissions.ADD_WARNING
  USERS_REMOVE_WARNING: 'users.remove_warning', // UserPermissions.REMOVE_WARNING
  USERS_VIEW_PERFORMANCE: 'users.view_performance', // UserPermissions.VIEW_PERFORMANCE
  USERS_DEACTIVATE: 'users.deactivate', // UserPermissions.DEACTIVATE
  USERS_REACTIVATE: 'users.reactivate', // UserPermissions.REACTIVATE
  USERS_VERIFY: 'users.verify', // UserPermissions.VERIFY
  USERS_INVITE: 'users.invite',
  USERS_SEND_PASSWORD_RESET: 'users.send_password_reset', // UserPermissions.SEND_PASSWORD_RESET
  USERS_STAFF_REPORT: 'users.staff_report', // UserPermissions.STAFF_REPORT

  // Models
  MODELS_EARNINGS: 'models.earnings',
  MODELS_CREATE: 'models.create', // ModelPermissions.CREATE
  MODELS_EDIT: 'models.edit', // ModelPermissions.EDIT
  MODELS_DELETE: 'models.delete', // ModelPermissions.DELETE

  // Notifications
  NOTIFICATIONS_CREATE: 'notifications.create', // NotificationPermissions.CREATE
  NOTIFICATIONS_DELETE: 'notifications.delete', // NotificationPermissions.DELETE

  // Holidays
  HOLIDAYS_VIEW: 'holidays.view', // HolidayPermissions.VIEW
  HOLIDAYS_MANAGE: 'holidays.manage', // HolidayPermissions.MANAGE
  HOLIDAYS_BYPASS_RESTRICTIONS: 'holidays.bypass_restrictions', // HolidayPermissions.BYPASS_RESTRICTIONS

  // Tickets
  TICKETS_VIEW: 'tickets.view', // TicketPermissions.VIEW
  TICKETS_CREATE: 'tickets.create', // TicketPermissions.CREATE
  TICKETS_REPLY: 'tickets.reply', // TicketPermissions.REPLY
  TICKETS_CLOSE: 'tickets.close', // TicketPermissions.CLOSE
  TICKETS_REOPEN: 'tickets.reopen', // TicketPermissions.REOPEN
  TICKETS_VIEW_ALL: 'tickets.view_all', // TicketPermissions.VIEW_ALL
  TICKETS_MANAGE: 'tickets.manage', // TicketPermissions.MANAGE
  TICKETS_ADD_PARTICIPANTS: 'tickets.add_participants', // TicketPermissions.ADD_PARTICIPANTS
  TICKETS_CATEGORY_MANAGERS: 'tickets.category_managers', // TicketPermissions.CATEGORY_MANAGERS

  // Requests
  REQUESTS_OVERWATCH: 'requests.overwatch', // RequestPermissions.OVERWATCH
  REQUESTS_VIEW_OVERWATCH: 'requests.view_overwatch', // RequestPermissions.VIEW_OVERWATCH
  REQUESTS_MANAGE_OVERWATCH: 'requests.manage_overwatch', // RequestPermissions.MANAGE_OVERWATCH
  REQUESTS_URGENT: 'requests.urgent', // RequestPermissions.URGENT

  OVERTIME_REQUEST: 'overtime.request', // RequestPermissions.REQUEST_OVERTIME
  OVERTIME_MANAGE: 'overtime.manage', // RequestPermissions.MANAGE_OVERTIME

  // Pay & Financial
  PAY_BONUS: 'pay.bonus', // PayPermissions.BONUS
  PAY_CALCULATE: 'pay.calculate', // PayPermissions.CALCULATE_PAY
  PAY_VIEW_OWN: 'pay.view_own', // PayPermissions.VIEW_PAY
  PAY_VIEW_OTHERS: 'pay.view_others', // PayPermissions.VIEW_OTHER_USERS_PAY
  PAY_RESET_HOURS_TRACKER: 'pay.reset_hours_tracker', // PayPermissions.RESET_HOURS_TRACKER
  PAY_GENERATE_INVOICES: 'pay.generate_invoices', // PayPermissions.GENERATE_INVOICES
  PAY_VIEW_INVOICES: 'pay.view_invoices', // PayPermissions.VIEW_INVOICES
  PAY_RELEASE_INVOICES: 'pay.release_invoices', // PayPermissions.RELEASE_INVOICES
  PAY_MISC_PAYMENTS: 'pay.misc_payments', // PayPermissions.MISC_PAYMENTS
  PAY_REFERRALS: 'pay.referrals', // PayPermissions.REFERRALS
  PAY_CYCLE_FORM: 'pay.cycle_form', // PayPermissions.CYCLE_FORM

  SHEETS_PAY_SUMMARY: 'sheets.pay_summary',
  SHEETS_MODEL_PAY_SUMMARY: 'sheets.model_pay_summary',
  SHEETS_MODEL_PPV: 'sheets.model_ppv',
  SHEETS_INVOICES: 'sheets.invoices',
  SHEETS_STAFF_REPORT: 'sheets.staff_report',
  SHEETS_MODEL_STATISTICS: 'sheets.model_statistics',
  SHEETS_FAN_GAIN: 'sheets.fan_gain',
  SHEETS_MODEL_EARNINGS_REPORT: 'sheets.model_earnings_report',
  SHEETS_FAN_GAIN_PER_AD: 'sheets.fan_gain_per_ad',

  // Financial Data
  COSTS_MANAGE: 'costs.manage', // CostPermissions.MANAGE
  EXCHANGE_RATES_VIEW: 'exchange_rates.view', // ExchangeRatePermissions.VIEW
  MISC_PAYMENTS_VIEW: 'misc_payments.view', // MiscPaymentPermissions.VIEW
  MISC_PAYMENTS_MANAGE: 'misc_payments.manage', // MiscPaymentPermissions.MANAGE
  SCHEDULE_PAY_EXCEPTIONS_MANAGE: 'schedule_pay_exceptions.manage', // SchedulePayExceptionPermissions.MANAGE

  // Bug/Feature Requests
  SUPPORT_CREATE: 'support.create', // SupportPermissions.CREATE
  SUPPORT_APPROVE: 'support.approve', // SupportPermissions.APPROVE
  SUPPORT_VIEW_ALL: 'support.view_all', // SupportPermissions.VIEW_ALL
  NAVIGATION_SUPPORT: 'navigation.support', // NavigationPermissions.SUPPORT
} as const;

// Type definitions
export type Permission = typeof Permissions[keyof typeof Permissions];

